import React from 'react';
import { cn } from '../cn';
import { ContentBlock } from '../ContentBlock/ContentBlock';

export type CallToActionProps = React.PropsWithChildren<{
  title: string,
  highlight?: string,
  highlightClassName?: string,
  text?: string | React.ReactNode,
  textClassName?: string,
  addOn?: JSX.Element,
  button?: JSX.Element,
  className?: string,
  type?: 'narrow' | 'extended' | 'wide' | 'basic' | 'full',
}>;

export const CallToAction = (props:CallToActionProps): JSX.Element => {
  return (
    <ContentBlock
      className = {cn(props.className)}
      title = {props.title}
      highlight = {props.highlight}
      highlightClassName = {props.highlightClassName}
      text = {props.text}
      textClassName={props.textClassName}
      type={props.type}
      addOn = {<div className='flex flex-col gap-grid-riac'>
        {props.addOn}
        {props.button && (
          <div className = 'flex flex-row justify-around'>
            {props.button}
          </div>
        )}
      </div>}
    />
  );
};
